/*
 * English (default) page content.
 *
 * Assembled from the per-section dictionaries; imported by the English
 * entry point. Adding a language means writing a parallel file that
 * satisfies the same PageContent interface.
 */
import type { PageContent } from "../types";
import { hero } from "./hero";
import { logoWall } from "./logoWall";
import { partners } from "./partners";
import { pillars } from "./pillars";
import { worksFor } from "./worksFor";
import { features } from "./features";
import { customizeGrid } from "./customizeGrid";
import { pricing } from "./pricing";
import { resources } from "./resources";
import { faq } from "./faq";
import { finalCta } from "./finalCTA";
import { colophon } from "./colophon";
import { sectionNav } from "./sectionNav";
import { themeToggle } from "./themeToggle";
import { langToggle } from "./langToggle";

export const en: PageContent = {
  hero,
  logoWall,
  partners,
  pillars,
  worksFor,
  features,
  customizeGrid,
  pricing,
  resources,
  faq,
  finalCta,
  colophon,
  sectionNav,
  themeToggle,
  langToggle,
};
